import {
  AlignPlugin,
  BoldPlugin as DefaultBoldPlugin,
  ItalicPlugin,
  StrikethroughPlugin,
  UnderlinePlugin,
  SoftBreakPlugin,
  EditablePlugins,
  ExitBreakPlugin,
  ResetBlockTypePlugin,
  pipe,
  ListPlugin,
  withList,
  withNodeID,
  withDeserializeHTML,
  withInlineVoid,
  isBlockAboveEmpty,
  isSelectionAtBlockStart,
  deserializeHTMLToDocumentFragment,
  DEFAULTS_BOLD,
  setDefaults,
  getLeafDeserializer
} from '@udecode/slate-plugins';

export const deserializeBold = (options) => {
  const { bold } = setDefaults(options, DEFAULTS_BOLD);

  return {
    leaf: getLeafDeserializer({
      type: bold.type,
      rules: [
        { nodeNames: ['STRONG', 'B'] },
        {
          style: {
            fontWeight: ['600', '700', 'bold'],
          },
        },
      ],
    }),
  };
}

export function BoldPlugin(options) {
  return { 
    ...DefaultBoldPlugin(options),
    deserialize: deserializeBold(options)
  }
}

export const withPreventIframe = () => (editor) => {
  const { insertData } = editor;

  editor.insertData = (data) => {
    const html = data.getData('text/html');

    if (html?.toLowerCase().includes('<iframe')) {
      return;
    } else {
      insertData(data);
    }
  };

  return editor;
};
